import PocDasboardHomeContainer from './containers/dashboard/PocDashboardHomeContainer';
import SurveyResponseVertical from './containers/dashboard/surveyResponseVerticalContainer';
import PocOrganizationHomeContainer from './containers/organization/organizationHomeContainer';
import ROUTE from './routes';
import AM_ROUTE from './account-manager/routes';
import CreateInviteUserContainer from './containers/organization/createInvitationContiner';
import assessmentReportContainer from './containers/dashboard/assessmentReportContainer';
import TeamAssessmentContainer from './containers/dashboard/teamAssessmentReportContainer';
import ModuleUsageReportContainer from './containers/dashboard/moduleUsageReportContainer';
import pocReportListContainer from './containers/poc_report/pocReportListContainer';
import PocUserReportContainer from './containers/poc_report/pocUserReportContainer'
import orgTicketsContainer from './account-manager/containers/orgTicketsContainer';
import AmPermissionsContainer from './account-manager/containers/AmPermissionsContainer';

export default [
        {
                name: 'PocDashboardHome',
                path: ROUTE.dashboard_home,
                component: PocDasboardHomeContainer,
                exact: true,
                protect: true
        },
        {
                name: "Poc Organization Home",
                path: ROUTE.poc_organization,
                component: PocOrganizationHomeContainer,
                exact: true,
                protect: true
        },
        {
                name: "Poc Vertical Detail",
                path: ROUTE.poc_vertical_detail,
                component: SurveyResponseVertical,
                exact: true,
                protect: true
        },
        {
                name: "Poc Create Invitation",
                path: ROUTE.create_invitation,
                component: CreateInviteUserContainer,
                exact: true,
                protect: true
        },
        {
                name: "Poc assessment report",
                path: ROUTE.assessment_report,
                component: assessmentReportContainer,
                exact: true,
                protect: true
        },
        {
                name: "Poc team assessment report",
                path: ROUTE.team_assessment_report,
                component: TeamAssessmentContainer,
                exact: true,
                protect: true
        },
        {
                name: "Module usage report",
                path: ROUTE.module_usage,
                component: ModuleUsageReportContainer,
                exact: true,
                protect: true
        },
        {
                name: "Survey report",
                path: ROUTE.poc_report,
                component: pocReportListContainer,
                exact: true,
                protect: true
        },
        {
                name: "User report",
                path: ROUTE.poc_user_report,
                component: PocUserReportContainer,
                exact: true,
                protect: true
        },
        {
                name: 'AM DashboardHome',
                path: AM_ROUTE.dashboard_home,
                component: PocDasboardHomeContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM Organization Home",
                path: AM_ROUTE.am_organization,
                component: PocOrganizationHomeContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM Vertical Detail",
                path: AM_ROUTE.am_vertical_detail,
                component: SurveyResponseVertical,
                exact: true,
                protect: true
        },
        {
                name: "AM Create Invitation",
                path: AM_ROUTE.create_invitation,
                component: CreateInviteUserContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM assessment report",
                path: AM_ROUTE.assessment_report,
                component: assessmentReportContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM team assessment report",
                path: AM_ROUTE.team_assessment_report,
                component: TeamAssessmentContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM Module usage report",
                path: AM_ROUTE.module_usage,
                component: ModuleUsageReportContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM Survey report",
                path: AM_ROUTE.am_report,
                component: pocReportListContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM User report",
                path: AM_ROUTE.am_user_report,
                component: PocUserReportContainer,
                exact: true,
                protect: true
        },
        {
                name: "AM Org Tickets",
                path: AM_ROUTE.am_org_tickets,
                component: orgTicketsContainer,
                exact: true,
                protect: true
        },
        {
                name: 'AM Permissions',
                path: AM_ROUTE.am_permissions,
                component: AmPermissionsContainer,
                exact: true,
                protect: true
        }
]